import styled from 'styled-components';

interface IDisabledProps {
    disabled?: boolean;
}

interface IInputProps extends IDisabledProps {
    hasError: boolean;
}

export const FormInputContainer = styled.div`
    --slider-size: 1.5rem;
    --slider-track-height: 2px;

    display: flex;
    flex-flow: column;
    position: relative;
    width: 100%;
`;

export const StyledInput = styled.input<IInputProps>`
    --slider-background: white;
    --slider-color: ${({ theme, disabled }) =>
        disabled ? theme.colors.mediumShadow : theme.colors.buttonPrimaryBg};

    position: absolute;
    top: 50%;
    left: 0;
    right: 0;

    &,
    &::-webkit-slider-runnable-track,
    &::-webkit-slider-thumb {
        appearance: none;
        background: none;
    }

    &::-webkit-slider-runnable-track {
        height: var(--slider-track-height);
        background: var(--slider-color);
    }

    &::-webkit-slider-thumb {
        position: relative;
        height: var(--slider-size);
        width: var(--slider-size);
        margin-top: calc(
            -1 * var(--slider-size) / 2 + var(--slider-track-height) / 2
        );
        cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
        background: linear-gradient(
                0deg,
                var(--slider-background) 25%,
                transparent 25%,
                transparent 75%,
                var(--slider-background) 75%
            ),
            linear-gradient(
                90deg,
                var(--slider-background) 30%,
                var(--slider-color) 30.1%,
                var(--slider-color) 39.9%,
                var(--slider-background) 40%,
                var(--slider-background) 60%,
                var(--slider-color) 60.1%,
                var(--slider-color) 69.9%,
                var(--slider-background) 70%
            ),
            var(--slider-background);
        border: 2px solid var(--slider-color);
        border-radius: 2rem;
        z-index: 1;
    }
`;

interface IEdgeShadowProps {
    lowerBound: number;
    upperBound: number;
}

export const EdgeShadow = styled.div<IEdgeShadowProps>`
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: var(--slider-track-height);
    background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.9) ${({ lowerBound }) => lowerBound}%,
        transparent ${({ lowerBound }) => lowerBound}%,
        transparent ${({ upperBound }) => upperBound}%,
        rgba(255, 255, 255, 0.9) ${({ upperBound }) => upperBound}%
    );
    pointer-events: none;
`;

export const StyledError = styled.span`
    min-height: 1.25rem;
    margin-top: 0.375rem;
    color: ${({ theme }) => theme.colors.formError};
    font-size: ${({ theme }) => theme.fontSizes[3]};
`;
